export var PERCENTAGE_VALUE = 'percentage value';
export var VALUE = 'value';
export var DIFFERENCE = 'difference';
export var FUNNEL_STEP = 'step';
export var COLUMN_JOIN = '_';
